import React, { useEffect, useRef } from "react";

import { Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
// import { useTranslation } from "react-i18next";

import useStyles from "./IframeSportsbook.style";
import useWindowSize from "../../../Hooks/useWindowSize";
import SuspenseLoader from "../../../components/SuspenseLoader";
import { getlaunchIframeStart } from "../../../sportbookNode-saga/redux/sportsIframe";


const IframeSportsBook = () => {
  const classes = useStyles();
  const [windowHeight] = useWindowSize();
  const iframeRef = useRef();
  const orientation = useSelector((state) => state.settings.orientation);
  const { isGameStarted } = useSelector((state) => state.casinoGames);
  const dispatch = useDispatch();
   const { "*": subPath } = useParams();
  const { iframeLoading, iframeData } = useSelector(
    (state) => state.sportbook.sportsIframe
  );

  useEffect(() => {
   dispatch(
      getlaunchIframeStart(subPath ? { sportsUrl: `/${subPath}` } : undefined)
    );
  }, [dispatch, subPath]);

  return (
    <>
      {iframeLoading ? (
        <SuspenseLoader />
      ) : (
        <>
          <div
            className={
              isGameStarted && isMobile ? classes.gameWrap : classes.iframeWrap
            }
          >
            <Grid container>
              <Grid item xs={12} className="custom-iframe-wrap">
                <Grid
                  style={
                    isMobile
                      ? {
                          height:
                            windowHeight -
                            (orientation === "PORTRAIT" ? 130 : 8),
                          marginTop: orientation === "PORTRAIT" ? "56px" : "2px"
                        }
                      : null
                  }
                  className={classes.iframeContent}
                >
                  <iframe
                    className={classes.iframecontainer}
                    src={iframeData}
                    ref={iframeRef}
                    title="gameFrame"
                    width="100%"
                    height="100%"
                  />
                </Grid>
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </>
  );
};

export default IframeSportsBook;
